import store from "../store";
import { serviceGetProgramDoctor } from "../services/Program.service";

export const FETCH_INIT = "FETCH_INIT_PROGRAM_DOCTOR";
export const FETCHED = "FETCHED_PROGRAM_DOCTOR";
export const FETCHED_FAIL = "FETCHED_FAIL_PROGRAM_DOCTOR";
export const SET_SORTING = "SET_SORTING_PROGRAM_DOCTOR";
export const SET_FILTER = "SET_FILTER_PROGRAM_DOCTOR";
export const CHANGE_PAGE = "CHANGE_PAGE_PROGRAM_DOCTOR";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_PROGRAM_DOCTOR";
export const SET_ROW_SIZE = "SET_ROW_SIZE_PROGRAM_DOCTOR";
export const CLEAN_PROGRAM_DOCTOR = "CLEAN_PROGRAM_DOCTOR";

export function actionFetchProgramDoctor(
  index = 1,
  sorting = {},
  filter = {},
  shouldReset = false
) {
  const request = serviceGetProgramDoctor({
    index,
    row: sorting?.row,
    order: sorting?.order,
    ...filter,
  });
  return (dispatch) => {
    if (shouldReset) {
      dispatch({ type: CHANGE_PAGE, payload: 0 });
    }
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: 0 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionSetPageProgramDoctor(page, extraPayload) {
  const stateData = store.getState().program_doctor;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage || 0;
  const rowsPerPage = stateData.rowsPerPage || 10;

  // only ask the server for the next slab once the user reaches the end of
  // whatever has already been loaded
  if (totalLength <= (page + 1) * rowsPerPage) {
    store.dispatch(
      actionFetchProgramDoctor(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
        ...extraPayload,
      })
    );
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}

export function actionChangePageProgramDoctor(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionSetRowSizeProgramDoctor(payload) {
  return {
    type: SET_ROW_SIZE,
    payload,
  };
}

export function actionCleanProgramDoctor() {
  return {
    type: CLEAN_PROGRAM_DOCTOR,
    payload: null,
  };
}
